export default __webpack_public_path__ + "static/media/3_Intro.bfe2e8ed.mp4";